/* eslint-disable @next/next/no-img-element */

import React, { useEffect, useMemo, useState } from 'react'
import { useQueryClient } from 'react-query'
import { useCategoryChildrenByUid } from '~src/hook/useCategoryChildren'
import { encode } from '~src/util'
import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import TitleAni from './TitleAni'

type TProps = {
  dataBrand: any
}

export const OnWorld: React.FC<TProps> = ({ dataBrand }) => {
  const dataWorld = dataBrand?.items?.find((item: any) => item?.identifier == 'home-page-branchs')

  const queryClient = useQueryClient()
  const defaultWebsiteFilter = queryClient.getQueryData<TDefaultWebsiteFilter>([
    'GET_DEFAULT_FILTER',
  ])

  const router = useRouter()

  const content = dataWorld?.nodes?.items?.find(
    (item: any) => item?.classes == 'description'
  )?.content

  const [numberActive, setNumberActive] = useState(1)
  const [selectCompany, setSelectCompany] = useState<TChildrenCategories | null>(null)

  // Danh sách loại thương hiệu (con của danh mục gốc Thương hiệu)
  const { data: dataCategoriesByCompany } = useCategoryChildrenByUid(
    defaultWebsiteFilter?.thuong_hieu ? encode(String(defaultWebsiteFilter.thuong_hieu)) : null
  )

  const arrayCompany = useMemo(() => {
    if (!!dataCategoriesByCompany) {
      const dataClone = JSON.parse(JSON.stringify(dataCategoriesByCompany))
      if (numberActive === 1) {
        setSelectCompany(dataClone?.[0])
        return dataClone?.splice(0, 8)
      }
      if (numberActive === 2) {
        setSelectCompany(dataClone?.[0])
        return dataClone?.splice(8, 8)
      }
      if (numberActive === 3) {
        setSelectCompany(dataClone?.[0])
        return dataClone?.splice(16, 8)
      }
    }
  }, [numberActive, dataCategoriesByCompany])

  return (
    <div className="on-world overflow-hidden pt-[10rem] max-md:pt-[0rem]">
      <div className="inner-on-world">
        <div className="ani-arrow-svg absolute right-[-4%] top-[50%] translate-y-[-50%] w-[15%]">
          <svg
            width="160"
            height="426"
            viewBox="0 0 242 426"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M241.5 394.289L241.5 425.25L120.469 360.748L1.52588e-05 425.25L1.5628e-05 394.289L120.469 330.156L241.5 394.289Z"
              fill="#239F40"
            />
            <path
              d="M241.5 341.789L241.5 372.75L120.469 308.248L1.52588e-05 372.75L1.5628e-05 341.789L120.469 277.656L241.5 341.789Z"
              fill="#239F40"
            />
            <path
              d="M241.5 289.289L241.5 320.25L120.469 255.748L1.52588e-05 320.25L1.5628e-05 289.289L120.469 225.156L241.5 289.289Z"
              fill="#239F40"
            />
            <path
              d="M241.5 236.789L241.5 267.75L120.469 203.248L1.52588e-05 267.75L1.5628e-05 236.789L120.469 172.656L241.5 236.789Z"
              fill="#239F40"
            />
            <path
              d="M241.5 184.289L241.5 215.25L120.469 150.748L1.52588e-05 215.25L1.5628e-05 184.289L120.469 120.156L241.5 184.289Z"
              fill="#239F40"
            />
            <path
              d="M241.5 64.5017L241.5 158.858L120.469 94.3568L1.52588e-05 158.858L1.6384e-05 64.5017L120.469 1.43657e-06L241.5 64.5017Z"
              fill="#239F40"
            />
          </svg>
        </div>
        <div className="text-position !bottom-1/4 md:!bottom-[60%] xl:!bottom-[80%] 2xl:!bottom-[35%] !z-10">
          <span>otpcom</span>
        </div>
        <div className="city-position">
          <img src="/image/City.png" alt="" />
        </div>
        <div className="containers">
          <div className="title">
            <div className="title-left">
              <div className="icon-center icon-brand">
                <img src="/image/ic-brand.svg" alt="" />
              </div>
              <TitleAni title="THƯƠNG HIỆU TRÊN KHẮP THẾ GIỚI"></TitleAni>
              <div className="sub-title" dangerouslySetInnerHTML={{ __html: content }}></div>
            </div>
          </div>
          <div className="content-on-world">
            <div className="content-left">
              <div className="content-slide">
                {arrayCompany?.length > 0 &&
                  arrayCompany?.map((item: TChildrenCategories, index: number) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectCompany(item)
                        // router.push(`/${item?.url_path}`)
                      }}
                      className={`car-item ${index == 0 && 'first'}  ${
                        // selectCompany?.image == item?.image && 'isSelect'
                        selectCompany?.image == item?.image && ''
                      } `}
                    >
                      <div className={`img `}>
                        <img src={item?.image} alt="" className="h-full" />
                      </div>
                    </div>
                  ))}
              </div>

              {/* <div className="grid grid-cols-2 overflow-hidden grid-rows-2 gap-[0.2rem] border-solid border-[0.2rem] border-[#333] bg-black rounded-[2.4rem]">
                {arrayCompany?.length > 0 &&
                  arrayCompany?.map((item: TChildrenCategories, index: number) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectCompany(item)
                        router.push(`/${item?.url_path}`)
                      }}
                      className={`car-item h-[20rem] bg-white ${index == 0 && 'first'}  ${
                        selectCompany?.image == item?.image && 'isSelect'
                      } `}
                    >
                      <div className={`img`}>
                        <img src={item?.image} alt="" />
                      </div>
                    </div>
                  ))}
              </div> */}
            </div>
            <div className="content-right">
              <div className="inner-content-right">
                <div className="the-road">
                  <div className="the-car__wrapper js-scroll gap-4 flex flex-col">
                    {/* <div className="text-position">
                      <span>otpcom</span>
                    </div> */}
                    {/* <img
                      id="img-car"
                      className="js-scroll"
                      src={`${selectCompany?.image_car}`}
                      alt=""
                      srcSet={selectCompany?.image_car}
                    /> */}
                    {selectCompany?.image_car && (
                      <motion.div
                        key={selectCompany?.image_car}
                        initial={{ opacity: 0, x: '100%', top: '10% !important' }}
                        animate={{ opacity: 1, x: '0%' }}
                        transition={{ duration: 0.8 }}
                      >
                        <div className="img pt-[calc(516/820*100%)] relative">
                          <img
                            src={selectCompany?.image_car}
                            alt=""
                            className="absolute top-[0] left-[0] w-full h-full object-cover"
                          />
                        </div>
                      </motion.div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
